import { useEffect, useState } from "react";
import { BellRing } from "lucide-react";

export default function EnableAlertsButton() {
  const supported = typeof window !== "undefined" && "Notification" in window;
  const [perm, setPerm] = useState(supported ? Notification.permission : "unsupported");

  useEffect(() => {
    if (!supported) return;
    const recheck = () => setPerm(Notification.permission);
    window.addEventListener("focus", recheck);
    return () => window.removeEventListener("focus", recheck);
  }, [supported]);

  if (!supported || perm === "granted") return null;

  const denied = perm === "denied";
  const enable = async () => {
    if (denied) return;
    try {
      setPerm(await Notification.requestPermission());
    } catch {
      /* ignore */
    }
  };

  return (
    <button
      type="button"
      onClick={enable}
      data-testid="enable-alerts-btn"
      title={denied
        ? "Notifications are blocked — enable them in your browser site settings."
        : "Enable desktop alerts for scheduled calls & new leads"}
      className="fixed right-14 top-3 z-50 flex h-9 items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 text-xs font-medium text-amber-700 shadow-sm transition-colors hover:bg-amber-100"
    >
      <BellRing className="h-4 w-4" />
      <span className="hidden sm:inline">{denied ? "Alerts blocked" : "Enable alerts"}</span>
    </button>
  );
}
